module.exports = __webpack_public_path__ + "img/c07_unitstartechberserkerchampion_Normal_ua.cbfb275f.webp";